import {
  AfterViewInit,
  Component,
  ContentChild,
  Directive,
  EventEmitter,
  Injectable,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { ColDef, ColGroupDef } from 'ag-grid-community';
import { ApiGrid, ClickedEvent, SortChange } from '../grid/grid.component';
import { Page } from '../rest/rest.service';
import { MoAddButtonTemplateDirective } from '../search/search.component';

@Directive({ selector: '[gq-search-crud-body]' })
export class SearchCrudBodyTemplate {
  constructor(public template: TemplateRef<any>) {}
}

@Injectable()
export class MatPaginatorIntlCro extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Página';
  override nextPageLabel = 'Next';
  override previousPageLabel = 'Previous';

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return 'Page 0 of ' + length;
    }
    length = Math.max(length, 0);
    //const startIndex = page * pageSize;
    let totalPage = length / pageSize;
    totalPage = Math.ceil(totalPage);
    return 'Page ' + (page + 1) + ' of ' + totalPage;
  };
}

@Component({
  selector: 'gq-search-crud',
  templateUrl: './search-crud.component.html',
  styleUrls: ['./search-crud.component.scss'],
})
export class SearchCrudComponent implements AfterViewInit {
  @Input() public showText = true;
  @Input() public titleWindow = '';
  @Input() public classStyle = '';
  @Input() public showExport = false;
  @Input() public showExport1 = false;
  @Input() public showExport2 = false;
  @Input() public showExport1Text = '';
  @Input() public showExport2Text = '';
  @Input() public showImport = false;
  @Input() public showAdd = true;
  @Input() public addText = '';
  @Input() public filterText = '';
  @Input() public isOpen = false;
  @Input() public showHeader = true;

  @Input() public autoSizeColumnsToFit = true;
  @Input() public minCharactersToSearch = 3;

  @Input() public page: Page | undefined;

  @Input() public columnDefs: Array<ColDef | ColGroupDef> | undefined;
  @Input() public showLoadingOverlay: boolean = false;
  @Input() public showPaging: boolean = true;
  @Input() public searchText = "";

  @Input()
  public rowClassRules: ((params: any) => string | string[]) | null = null;

  @Input() public rowIdField: string | null = null;

  @ContentChild(MoAddButtonTemplateDirective, {
    read: TemplateRef,
    static: false,
  })
  MoAddButtonTemplate: TemplateRef<any> | undefined;
  @ContentChild(SearchCrudBodyTemplate, { read: TemplateRef, static: false })
  contentTemplate: TemplateRef<any> | undefined;

  @Output() onReady: EventEmitter<ApiGrid> = new EventEmitter();
  @Output() onClickSearch: EventEmitter<string> = new EventEmitter();
  @Output() onSearch: EventEmitter<object> = new EventEmitter();
  @Output() onClickExport: EventEmitter<object> = new EventEmitter();
  @Output() onClickExport1: EventEmitter<object> = new EventEmitter();
  @Output() onClickExport2: EventEmitter<object> = new EventEmitter();
  @Output() onClickImport: EventEmitter<File> = new EventEmitter();
  @Output() onClickAdd: EventEmitter<object> = new EventEmitter();

  @Output() public onItemClicked: EventEmitter<ClickedEvent> =
    new EventEmitter();
  @Output() public onItemDoubleClicked: EventEmitter<ClickedEvent> =
    new EventEmitter();
  @Output() public onSortChanged: EventEmitter<SortChange> = new EventEmitter();

  public isOpenFilter: boolean = false;
  public gridApi?: ApiGrid;

  ngAfterViewInit() {
    console.log();
  }
  public onAdd(): void {
    this.onClickAdd.emit();
  }

  public onExport(): void {
    this.onClickExport.emit();
  }

  public onExport1(): void {
    this.onClickExport1.emit();
  }

  public onExport2(): void {
    this.onClickExport2.emit();
  }

  public onImport(file: File): void {
    this.onClickImport.emit(file);
  }

  public _onRowClicked(params: any) {
    this.onItemClicked.emit(params);
  }

  public _onRowDoubleClicked(params: any) {
    this.onItemDoubleClicked.emit(params);
  }

  public _onSortChanged(params: any) {
    this.onSortChanged.emit(params);
  }

  public onPage($event: { pageIndex: number; pageSize: number }) {
    if (this.page === undefined) {
      this.page = new Page();
    }

    this.page.pageIndex = $event.pageIndex + 1;
    this.page.pageSize = $event.pageSize;
    this._onSearch();
  }

  public _onReady(gridApi: ApiGrid) {
    this.gridApi = gridApi;
    this.onReady.emit(gridApi);
  }

  public _onClickSearch(searchText: string | undefined): void {
    this.onClickSearch.emit(searchText);
  }

  public _onSearch(): void {
    this.onSearch.emit(this.page);
  }

  public onOpenCloseFilter(event: boolean) {
    this.isOpenFilter = event;
  }

  readonly maxButtons = 5;

  get pageIndex0(): number {
    return Math.max(0, (this.page?.pageIndex ?? 1) - 1);
  }

  get pageCount(): number {
    const size = this.page?.pageSize ?? 1;
    const total = this.page?.recordCount ?? 0;
    return Math.max(1, Math.ceil(total / size));
  }

  get isTruncated(): boolean {
    return this.pageCount > this.maxButtons;
  }

  get visiblePages0(): number[] {
    const pc = this.pageCount;
    const current = this.pageIndex0;

    if (!this.isTruncated) return this.range(0, pc - 1);

    // 7 slots = 1 y última (siempre) + 5 centrales
    const innerCount = this.maxButtons - 2; // 5
    const half = Math.floor(innerCount / 2); // 2

    let start = current - half;
    let end = current + half;

    // el bloque central NUNCA incluye 0 ni pc-1
    if (start < 1) { start = 1; end = start + innerCount - 1; }
    if (end > pc - 2) { end = pc - 2; start = end - (innerCount - 1); }

    return this.range(start, end);
  }

  get showStartEdge(): boolean {
    return this.isTruncated; // <-- SIEMPRE muestra "1"
  }
  get showStartDots(): boolean {
    return this.isTruncated && this.visiblePages0[0] > 1; // gap entre 1 y el primer central
  }

  get showEndEdge(): boolean {
    return this.isTruncated; // <-- SIEMPRE muestra "última"
  }
  get showEndDots(): boolean {
    const lastVisible = this.visiblePages0[this.visiblePages0.length - 1];
    return this.isTruncated && lastVisible < this.pageCount - 2; // gap antes de la última
  }

  goTo(pageIndex0: number): void {
    const pc = this.pageCount;
    const next0 = Math.min(Math.max(pageIndex0, 0), pc - 1);

    const evt: PageEvent = {
      pageIndex: next0,
      pageSize: this.page?.pageSize ?? 10,
      length: this.page?.recordCount ?? 0,
      previousPageIndex: this.pageIndex0
    };

    this.onPage(evt);
  }

  private range(start: number, end: number): number[] {
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

}

export class PaginatorI18n {
  getPaginatorIntl(): MatPaginatorIntl {
    const paginatorIntl = new MatPaginatorIntl();
    paginatorIntl.itemsPerPageLabel = 'Items'; // this.translate.transform('default-paging-itemsPerPageLabel');
    paginatorIntl.nextPageLabel = 'Siguiente'; //this.translate.transform('default-paging-nextPageLabel');
    paginatorIntl.previousPageLabel = 'Anterior'; //this.translate.transform('default-paging-previousPageLabel');
    paginatorIntl.firstPageLabel = 'Primer'; //this.translate.transform('default-paging-firstPageLabel');
    paginatorIntl.lastPageLabel = 'Ulimo'; //this.translate.transform('default-paging-lastPageLabel');
    paginatorIntl.getRangeLabel = this.getRangeLabel.bind(this);
    return paginatorIntl;
  }

  private getRangeLabel(
    page: number,
    pageSize: number,
    length: number
  ): string {
    if (length === 0 || pageSize === 0 || length <= pageSize) {
      return `no hay registros ${length}`; //this.translate.transform('default-paging-getRangeVacioLabel', { length });
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return `pagina ${startIndex + 1} de ${endIndex} registros ${length}`; //this.translate.transform('default-paging-getRangeLlenoLabel', { startIndex: startIndex + 1, endIndex, length });
  }
}
